export class LocalizedContent {
  public readonly language: string = 'en';
  public readonly content: string = '';
  public readonly duration: number = 0;

  constructor(props: Partial<LocalizedContent> = {}) {
    Object.assign(this, props);
  }
}
